import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { useAuth } from 'shared/misc/hooks/useAuth';
import { gql } from 'shared/__generated__';
import NotFound from '../../components/not-found';
import ResetPasswordSignedOutForm from './-signed-out';
import ForgotPasswordForm from './-forgot-password';
import ResetPasswordSignedInForm from './-signed-in';

export const Route = createFileRoute('/reset-password/')({
  component: RouteComponent,
  validateSearch: z.object({
    key: z.string().optional(),
  }),
});

function RouteComponent() {
  const { key } = Route.useSearch();
  const { user } = useAuth();

  if (key) {
    return <ResetPasswordSignedOutForm />;
  }

  if (user) {
    return <ResetPasswordSignedInForm user={user} />;
  }

  if (!user && !key) {
    return <ForgotPasswordForm />;
  }

  return <NotFound />;
}

export const RESET_PASSWORD_MUTATION = gql(/** graphql **/ `
  mutation resetPassword($key: String, $newPassword: String!, $oldPassword: String) {
    resetPassword(key: $key, newPassword: $newPassword, oldPassword: $oldPassword)
}`);

export const SEND_RESET_PASSWORD_EMAIL = gql(/** graphql **/ `
  mutation sendResetPasswordEmail($email: String!) {
    sendResetPasswordEmail(email: $email)
  }
`);
